import React from 'react';
import Modal from '../../commonComponents/util/Modal';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import Select from '../../commonComponents/util/Select';
import RadioGroup from '../../commonComponents/util/RadioGroup';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import CreateCampaignRecipientModal from '../campaignsCommon/CreateCampaignRecipientModal';
import { isVowel, isValidEmail, locationIsIsraeli, validateAddressLocation, toTitleCase } from '../../../lib/utils';
import { RecipientTypes } from "../../../lib/systemVariables";

const initialState = {
    campaignList: {
        listType: 'internal',
        managerName: '',
        managerEmail: '',
        locationId: '',
        categoryId: '',
        organizationId: '',
        fundId: '',
        batch: false,
        allowDuplicates: false
    },
    categoryIsOrg: false,
    categoryOrgName: "",
    invalidData: false,
    error: false,
    submitAttempted: false,
    showModals: {
        createRecipientModal: false
    }
};

export default class CreateCampaignListModal extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = initialState;

        this.onChange = this.onChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.locationId && nextProps.locationId !== this.state.campaignList.locationId) {
            this.onChange("locationId", nextProps.locationId);
        }
    }

    onChange(name, value) {
        const prevVal = this.state.campaignList[value];
        if (name === "managerName") value = toTitleCase(value);
        this.setState({ campaignList: { ...this.state.campaignList, ...{ [name]: value } } }, () => {
            if (name === "categoryId") {
                let categoryIsOrg = false;
                let categoryOrgName = "";
                if (value) {
                    const orgCategoryIds = this.props.organizationCategories.map(category => category.key.toString());
                    categoryIsOrg = orgCategoryIds.indexOf(value.toString()) >= 0;
                    categoryOrgName = categoryIsOrg ? this.props.organizationCategories[orgCategoryIds.indexOf(value.toString())].value : "";
                }

                this.setState({
                    categoryIsOrg,
                    categoryOrgName,
                    campaignList: { ...this.state.campaignList, organizationId: '' }
                });

            } else if (name === "listType") {
                this.setState({
                    campaignList: {
                        ...this.state.campaignList,
                        managerName: '',
                        managerEmail: ''
                    },
                    invalidData: false,
                    submitAttempted: false
                });
            } else if (name === "locationId") {
                if (this.state.campaignList.organizationId) {
                    const org = this.props.organizations[this.props.organizations.map(o => o.key.toString()).indexOf(this.state.campaignList.organizationId.toString())];
                    if (org && !validateAddressLocation(this.props.locations, value, org.address)) {
                        this.setState({
                            campaignList: { ...this.state.campaignList, organizationId: '' }
                        });
                    }
                }
                if (this.state.campaignList.fundId && locationIsIsraeli(this.props.locations, value) !== locationIsIsraeli(this.props.locations, prevVal)) {
                    this.setState({
                        campaignList: { ...this.state.campaignList, fundId: '' }
                    });
                }
            }
        });
    }

    async onSubmit() {
        this.setState({ error: false, submitAttempted: true });

        const campaignList = this.state.campaignList;
        if (this.state.invalidData || !campaignList.listType || !campaignList.locationId || !campaignList.categoryId || !campaignList.fundId
            || (campaignList.listType === "external" && (!campaignList.managerName || !campaignList.managerEmail))
            || (this.state.categoryIsOrg && !campaignList.organizationId)) {
            return;
        }

        await this.props.createCampaignList(this.state.campaignList);

        if (this.props.success) {
            this.onClose();
            if (this.props.onSuccess) this.props.onSuccess();
        } else {
            this.setState({ error: true });
        }
    }

    onClose() {
        this.props.close();
        this.setState(initialState);
    }

    validateEmail(email) {
        const isValid = isValidEmail(email);
        this.setState({ invalidData: !isValid });
        return isValid;
    }

    render() {
        const campaignList = this.state.campaignList;
        return (
            <Modal modalShowing={this.props.show}>
                {!this.state.showModals.createRecipientModal && <div className="modal-container">
                    <div className="modal large-modal">
                        <div className="modal-header">
                            <h4 className="page-header">Create Campaign List</h4>
                            <i className="icon ion-ios-close-empty" onClick={this.onClose.bind(this)}></i>
                        </div>
                        {this.props.isAdmin && <div className="modal-section">
                            <div className="custom-check-container">
                                <input
                                    type="checkbox"
                                    id="allow-duplicates"
                                    className="custom-check"
                                    name="allowDuplicates"
                                    onChange={event => this.onChange(event.target.name, event.target.checked)}
                                    checked={campaignList.allowDuplicates} />
                                <label htmlFor="allow-duplicates" className="secondary-text">Allow Duplicates</label>
                            </div>
                        </div>}
                        <div className="modal-section">
                            <div className="modal-row">
                                <div className="column-half">
                                    <RadioGroup title="Management" name="listType"
                                        value={campaignList.listType}
                                        options={[{ key: 'internal', value: 'Internal' }, { key: 'external', value: 'External' }]}
                                        onChange={this.onChange} />
                                </div>
                                {campaignList.listType === "external" && <div className="column-half">
                                <div>
                                     <label className="empty-label" style={{marginBottom: "6px"}}/>
                                    <div className="custom-check-container">
                                        <input
                                            type="checkbox"
                                            id="batch-list"
                                            className="custom-check"
                                            name="batch"
                                            onChange={event => this.onChange(event.target.name, event.target.checked)}
                                            checked={campaignList.batch} />
                                        <label htmlFor="batch-list" className="secondary-text">Batch</label>
                                    </div></div>
                                </div>}
                            </div>
                        </div>
                        {campaignList.listType === "external" && <div className="modal-section">
                            <div className="modal-row">
                                <div className="column-half">
                                    <ValidatedInput input={<input type="text" placeholder="Name" />}
                                        label="External Contact" name="managerName" value={campaignList.managerName} onChange={this.onChange}
                                        required={true} showRequiredError={this.state.submitAttempted} />
                                </div>
                                <div className="column-half">
                                    <ValidatedInput input={<input type="text" placeholder="Email" />}
                                        label="  " name="managerEmail" value={campaignList.managerEmail} onChange={this.onChange}
                                        required={true} showRequiredError={this.state.submitAttempted}
                                        validated={true} showValidationError={true} validate={this.validateEmail.bind(this)}
                                        errorMessage="Invalid Email Address" />
                                </div>
                            </div>
                        </div>}
                        <div className="modal-section">
                            <div className="modal-row">
                                <div className="column-half">
                                    <ValidatedInput input={<Select disabled={this.props.locationId}
                                        options={this.props.locations.map(locationGroup =>
                                            ({
                                                key: locationGroup.groupId,
                                                value: locationGroup.groupName,
                                                details: locationGroup.members.map(member => `${member.city}, ${member.state}`).join('\n')
                                            }))} />}
                                        label="Location" name="locationId" value={campaignList.locationId} onChange={this.onChange}
                                        required={true} showRequiredError={this.state.submitAttempted} />
                                </div>
                                <div className="column-half">
                                    <ValidatedInput input={<Select
                                        options={[
                                            ...this.props.organizationCategories.length ? [
                                                { optionGroup: true, label: "Organization" },
                                                ...this.props.organizationCategories,
                                                { optionGroup: true, label: "Individual" }
                                            ] : [],
                                            ...this.props.individualCategories
                                        ]} />}
                                        label="Category" name="categoryId" value={campaignList.categoryId} onChange={this.onChange}
                                        required={true} showRequiredError={this.state.submitAttempted} />
                                </div>
                            </div>
                        </div>
                        <div className="modal-section">
                            <div className="modal-row">
                                <div className="column-half">
                                    <ValidatedInput input={<Select disabled={!campaignList.locationId}
                                        options={locationIsIsraeli(this.props.locations, campaignList.locationId) ? this.props.ILFunds : this.props.USFunds} />}
                                        label="Fund" name="fundId" value={campaignList.fundId} onChange={this.onChange}
                                        required={true} showRequiredError={this.state.submitAttempted} />
                                </div>
                                <div className="column-half organization-column">
                                    {this.state.categoryIsOrg &&
                                        <div>
                                            <ValidatedInput input={<Select disabled={!campaignList.locationId}
                                                options={this.props.organizations
                                                    .filter(org => org.tags.indexOf(this.state.categoryOrgName) >= 0)
                                                    .filter(org => validateAddressLocation(this.props.locations, campaignList.locationId, org.address))} />}
                                                label={`Please select ${isVowel(this.state.categoryOrgName[0]) ? "an" : "a"} ${this.state.categoryOrgName}`} name="organizationId" value={campaignList.organizationId} onChange={this.onChange}
                                                required={true} showRequiredError={this.state.submitAttempted} />
                                        </div>}
                                    <FadeOutErrorMessage show={this.state.categoryIsOrg && campaignList.locationId && campaignList.categoryId
                                        && !this.props.organizations
                                            .filter(org => org.tags.indexOf(this.state.categoryOrgName) >= 0)
                                            .filter(org => validateAddressLocation(this.props.locations, campaignList.locationId, org.address)).length}
                                        message="There are no organizations matching the selected location and category." />
                                </div>
                            </div>
                        </div>
                        {this.props.loading ? <LoadingSpinner height="20" alignRight={true} /> :
                            <div className="modal-btns add-campaign-list-modal-btns">
                                {(this.state.categoryIsOrg && campaignList.locationId && campaignList.categoryId)
                                    && <button className="btn btn-accent2" onClick={this.toggleModal.bind(this, "createRecipientModal")}>Create Organization</button>}
                                <div className="text-right full-width">
                                    <button className="btn btn-accent" onClick={this.onClose.bind(this)}>Cancel</button>
                                    <button className="btn btn-primary" onClick={this.onSubmit.bind(this)}
                                        disabled={this.state.invalidData}>Submit</button>
                                    <FadeOutErrorMessage show={this.state.error} message={this.props.message} />
                                </div>
                            </div>}
                    </div>
                </div>}

                <CreateCampaignRecipientModal
                    show={this.state.showModals.createRecipientModal}
                    close={this.toggleModal.bind(this, "createRecipientModal")}
                    locationId={campaignList.locationId}
                    campaignTagId={campaignList.categoryId}
                    onContinue={org => this.onChange('organizationId', org.applicantId)}
                    recipientType={RecipientTypes.Organization} />

            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignsCommon/CreateCampaignListModal.jsx